<template>
    <div class="float-left" v-if="$temAcessoView('CONV-MEN-01')">
        <span class="text-primary float-left ml-1">
            <i
                class="fa fa-edit fa-lg icon-button"
                title="Atualizar"
                @click.stop="abrirModal()"
            ></i>
        </span>
        <prestacao-contas-mensal-form
            :mostrarModal="mostrarModal"
            :prestacoesContasMensalAtual="prestacao"
            :erros="erros"
            operacao="A"
            @fecharModal="fecharModal()"
            @salvar="salvar"
        ></prestacao-contas-mensal-form>
    </div>
</template>

<script>
import ConveniosServicos from '../../ConveniosServicos'
import PrestacaoContasMensalForm from './PrestacaoContasMensalForm'

export default {
    props: {
        prestacao: {
            type: Object
        }
    },

    components: {
        PrestacaoContasMensalForm
    },

    data() {
        return {
            mostrarModal: false,
            erros: []
        }
    },

    methods: {
        abrirModal() {
            this.mostrarModal = true
        },

        fecharModal() {
            this.mostrarModal = false
        },

        salvar(prestacaoAtualizada) {
            this.$store.dispatch('addRequest')
            let prestacaoAtualizadaDto = {
                idConvenio: this.$route.params.convenioId,
                idPrestacaoContasMensal:
                    prestacaoAtualizada.idPrestacaoContasMensal,
                dtCompetencia: this.$moment(
                    '01/' + prestacaoAtualizada.dtCompetencia,
                    'DD/MM/YYYY'
                ).format('YYYY-MM-DD'),
                dtPrestacao: this.$moment( prestacaoAtualizada.dtPrestacao, 'DD/MM/YYYY').format('YYYY-MM-DD'),
                nuReceitasDiversas: prestacaoAtualizada.nuReceitasDiversas,
                nuTotalGasto: prestacaoAtualizada.nuTotalGasto,
                nuTotalRendimentos: prestacaoAtualizada.nuTotalRendimentos
            }
            ConveniosServicos.atualizarPrestacaoContasMensal(
                prestacaoAtualizadaDto
            ).then((response) => {
                if (response) {
                    if (response.success) {
                        this.$emit('atualizarLista')
                        this.fecharModal()
                    } else {
                        this.erros = response.errors
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        }
    }
}
</script>

